import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../contexts/AuthContext';

function AppDataProvider({ children }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { tables, error } = useSelector(state => state.tables);
  const { fetchWithAuth, isAuthenticated, currentUser } = useAuth();

  useEffect(() => {
    const fetchTables = async () => {
      try {
        setLoading(true);
        dispatch({ type: 'FETCH_TABLES_START' });
        const response = await fetchWithAuth(`/tables`);

        if (!response.ok) {
          let payload = 'Failed to fetch tables';

          try {
            const data = await response.json();
            payload = data.error || data.detail || 'Failed to fetch tables';
          } catch (error) {}

          dispatch({ type: 'FETCH_TABLES_ERROR', payload });

          return;
        }

        const data = await response.json();

        dispatch({ type: 'FETCH_TABLES_SUCCESS', payload: data });
      } catch (error) {
        dispatch({ type: 'FETCH_TABLES_ERROR', payload: error.message });
      } finally {
        setLoading(false);
      }
    };

    if (error)
      return;

    if (!loading && tables.length === 0 && isAuthenticated && currentUser)
      fetchTables();

  }, [dispatch, tables.length, loading, error, isAuthenticated, currentUser]);

  return children;
}

export default AppDataProvider;